import { render, staticRenderFns } from "./Internal.vue?vue&type=template&id=8504fde4&scoped=true"
import script from "./Internal.js?vue&type=script&lang=js&external"
export * from "./Internal.js?vue&type=script&lang=js&external"
import style0 from "./Internal.scss?vue&type=style&index=0&id=8504fde4&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8504fde4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotMonksHeader: require('/home/runner/_work/app-hotmart-legal/app-hotmart-legal/components/Organisms/MonksHeader/MonksHeader.vue').default,HotHeaderSidebar: require('/home/runner/_work/app-hotmart-legal/app-hotmart-legal/components/Organisms/HeaderSidebar/HeaderSidebar.vue').default,HotHero: require('/home/runner/_work/app-hotmart-legal/app-hotmart-legal/components/Organisms/Hero/Hero.vue').default,HotLegalBanner: require('/home/runner/_work/app-hotmart-legal/app-hotmart-legal/components/Molecules/LegalBanner/LegalBanner.vue').default,HotFooter: require('/home/runner/_work/app-hotmart-legal/app-hotmart-legal/components/Organisms/Footer/Footer.vue').default})
